import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Header = ({ toggleSidebar, setIsSidebarOpen, isHeaderColorActive }) => {
  const location = useLocation();

  const skipHeader = () => {
    return location.pathname === "/register";
  };
  return (
    <header
      className={`flex justify-between items-center top-0 py-4 px-5 md:px-24 ${
        isHeaderColorActive ? "" : "bg-[#f6d6aa]"
      } text-white fixed w-full z-10`}
    >
      {!skipHeader() && (
        <a
          href="https://tool.metaluxe.com.au/"
          target="_blank"
          class="annotation mb-2"
          data-bs-toggle="tooltip"
          title="Click to Edits"
          rel="noreferrer"
        >
          <img
            src={`/images/${isHeaderColorActive ? "key-white.svg" : "key.svg"}`}
            className=" h-5 md:h-6"
            alt=""
          />
        </a>
      )}

      <Link
        to="/"
        onClick={() => setIsSidebarOpen(false)}
        reloadDocument
        className="absolute left-[50%] transform -translate-x-1/2 "
      >
        {!skipHeader() ? (
          <img
            src={`/images/${isHeaderColorActive ? "logo" : "logo-black"}.png`}
            className="h-8 md:h-11 "
            alt=""
          />
        ) : (
          <img
            src={`/images/${
              isHeaderColorActive ? "logo-black" : "logo-black"
            }.png`}
            className="h-8 md:h-11 "
            alt=""
          />
        )}
      </Link>
      {!skipHeader() ? (
        <>
          <Link to="/register" reloadDocument className="hidden md:block ">
            {isHeaderColorActive ? (
              <p className="text-p-m bg-gray-100 text-black font-bold py-2 px-6 hover:bg-black hover:text-white  hover:border-white z-[9999999]">
                REGISTER INTEREST
              </p>
            ) : (
              <p className="text-p-m bg-gray-100 hover:bg-black text-black hover:text-white border hover:border-white font-bold py-2 px-6 shadow-md hidden md:block">
                REGISTER INTEREST
              </p>
            )}
          </Link>
          <Link to="/register" reloadDocument className="block md:hidden ">
            <div
              className={`text-sm ${
                isHeaderColorActive ? "text-white" : "text-black"
              }`}
            >
              REGISTER
            </div>
          </Link>
        </>
      ) : (
        <span className="py-2 px-6"></span>
      )}
    </header>
  );
};

export default Header;
